import BaseComponent from 'bootstrap/js/src/base-component.js';
import EventHandler from 'bootstrap/js/src/dom/event-handler.js';
import { defineJQueryPlugin } from 'bootstrap/js/src/util/index.js';

const NAME = 'datepicker';
const DATA_KEY = 'bs.datepicker';
const EVENT_KEY = `.${DATA_KEY}`;
const DATA_API_KEY = '.data-api';

const SELECTOR_INPUT = '[data-bs-toggle="datepicker"]';
const EVENT_FOCUS_DATA_API = `focus${EVENT_KEY}${DATA_API_KEY}`;

class Datepicker extends BaseComponent {
  // Getters
  static get NAME() {
    return NAME;
  }

  // Static
  static jQueryInterface(config) {
    return this.each(function () {
      const data = Datepicker.getOrCreateInstance(this);

      if (config === 'toggle') {
        data[config]();
      }
    });
  }
}

/**
 * Data API implementation
 */
EventHandler.on(document, EVENT_FOCUS_DATA_API, SELECTOR_INPUT, (event) => {
  const input = event.target.closest(SELECTOR_INPUT);

  if (isTouchDevice()) {
    const datePicker = input.cloneNode(true);

    datePicker.type = 'date';
    datePicker.removeAttribute('data-bs-toggle');

    input.parentNode.prepend(datePicker);

    datePicker.focus();
    datePicker.showPicker();
    input.remove();

    datePicker.addEventListener('blur', function blurHandler() {
      if (!datePicker.value) {
        datePicker.parentNode.prepend(input);
        datePicker.remove();
        datePicker.removeEventListener('blur', blurHandler);
      }
    });
  } else {
    input.type = 'date';

    input.addEventListener('blur', function blurHandler() {
      if (!input.value) {
        input.type = 'text';
      }

      input.removeEventListener('blur', blurHandler);
    });
  }
});

function isTouchDevice() {
  return 'ontouchstart' in globalThis || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

/**
 * jQuery
 */
defineJQueryPlugin(Datepicker);

export default Datepicker;
